import firebase from '../firebase'
import Store from '../store/Store'
import DataHelpers from '../helpers/DataHelpers'
import AppHelpers from '../helpers/AppHelpers'
import OrderHelpers from '../helpers/OrderHelpers'

var db = firebase.database()

export default class {

static fetchItemSingle (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            let obj = this.objectFromSnapshot(snap)
            resolve(obj)
        })
    })       
}

static fetchValue (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            let result = snap.val()
            resolve(result)
        })
    })       
}

static fetchItemByName (baseRef, name) {
    return new Promise((resolve, reject) => {
        baseRef.orderByChild('name').equalTo(name).once('value', (snap) => {
            let objects = this.arrayFromSnapshot(snap)
            if(objects && objects.length)
                resolve(objects[0])
            else
                resolve(null)
        })
    })       
}

static objectFromSnapshot(snap) {
    let item = snap.val()
    if(!item)
        return null
    item.meta = {}
    item.meta.key = snap.key
    let pathArray = [...snap.ref.path.pieces_]
    if(pathArray.length > 2 && pathArray[0] == 'tenants')
        item.meta.tenantKey = pathArray[1]
        
    pathArray.pop()
    item.meta.path = pathArray.join('/')  
    return item  
}

static fetchItemsFromFirebase (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            resolve(this.arrayFromSnapshot(snap))
        }, (err) => {
            throw new Error('Cannot fetch items. ' + err)
        })
    })       
}   

static arrayFromSnapshot(snap) {
    let returnArr = []
    let ordered = false
    
    snap.forEach(childSnapshot => {
        let item = childSnapshot.val()
        item.meta = {}
        item.meta.key = childSnapshot.key
        let pathArray = snap.ref.path.pieces_
        if(pathArray.length > 2 && pathArray[0] == 'tenants')
            item.meta.tenantKey = pathArray[1]
        // if(pathArray.length > 3 && pathArray[2] == 'tasks') {
        //     item.meta.transactionKey = pathArray[3]
        // }
        if(item.order)
            ordered = true

        item.meta.path = pathArray.join('/')

        returnArr.push(item)
    })   
    if(ordered)
        returnArr = returnArr.sort(OrderHelpers.sortByOrder)
        
    return returnArr 
}

static safelyGetKey(obj) {
    let key
    if(obj.meta && obj.meta.key)
        key = obj.meta.key

    let oldKey = (obj['.key'] || obj.key)
    
    if(oldKey) {
        if(!key) {
            console.log('safelyGetKey ONLY has old key', obj)
            key = oldKey
        }
        else
            console.log('safelyGetKey has redundant old key', obj)
    }

    //check for algolia key
    if(!key && obj.objectID)
        key = obj.objectID

    if(!key && obj.uid)
        key = obj.uid
    
    return key
}

static safelyGetTenant(obj) {
    
    if(!obj)
        return Store.getters.tenantKey

    if(obj.meta && obj.meta.tenantKey)
        return obj.meta.tenantKey
    else if(obj.tenantKey)
        return obj.tenantKey
    else
        return Store.getters.tenantKey
}


static fetchItems(ref, storeName, localVariable) {
    if(Store.state[storeName].length) {
        console.log('fetchItems from cache', storeName)
        localVariable = Store.state[storeName]
        return
    }
    this.fetchItemsFromFirebase(ref).then(items => {
        console.log('fetchItems from db', storeName)

        let payload = {
            name: storeName,
            data: items,
        }
        Store.commit('saveItems', payload)
        localVariable = items
    })
}

static saveFieldToFirebase(ref, x) {
    //todo...  
}

static firebaseRefToPath(ref) {
    let refStr = ref.toString()
    let refArr = refStr.split(/\//).slice(3).join('/')
    return refArr
}

static firebaseRefToKey(ref) {
    let pathArray = [...ref.path.pieces_]
    pathArray.pop()
    return pathArray.join("/")
}

//no ['.key'] version
static snapshotToArray  (snapshot) {
    let returnArr = []

    snapshot.forEach(childSnapshot => {
        let item = childSnapshot.val(); 
        item.key = childSnapshot.key
        returnArr.push(item)
    })

    return returnArr
}

static makeItem(ref, ) {
    return {
        meta: {
            key: DataHelpers.getKey(),
            path: ref.toString().split('/').splice(3).join('/'),
        }
    }  
}

static makeRecord(table) {
    let record = {}
    table.fields.forEach(field => {
        record[field.name] = null
        if(field.default) {
            record[field.name] = this.defaultValue(field.default)
        }
        record.meta = {
            key: DataHelpers.getKey(),
            path: table.ref.toString().split('/').splice(3).join('/'),
        }
    })
    return record
}  

static defaultValue(field) {
    if(field == '[tenantKey]')
        return DataHelpers.getTenantKey()
    if(field == '[stamp]')
        return DataHelpers.getStamp()
    
}

static saveItem(item) {
    const savePath = item.meta.path
    let ref = DataHelpers.getRootRef().child(savePath).child(item.meta.key)
    let newItem = {...item}
    
    if(newItem.meta.savePosition && !newItem.order) {
        newItem.order = OrderHelpers.orderKey()
        if(newItem.meta.savePosition == 'top')
        newItem.order = 0 - newItem.order
    }
    
    delete newItem.meta
    
    if(this.debugMode()) {
        console.log('*** DEBUG MODE ***')
        console.log('Would normally save object', newItem)
        console.log('To path', savePath)
        return
    }
    

    ref.update(newItem)
}

static debugMode() {
    return AppHelpers.getApplicationData('debugMode')
}

static saveField(ref, value) {
    ref.set(value)
}

static deleteItem(item) {
    let ref = DataHelpers.getRootRef().child(item.meta.path).child(item.meta.key)
    ref.remove()
}

//Copy list from one path to another with new keys...

static copyItems(fromRef, toRef) {
    let toPath = this.firebaseRefToPath(toRef)
    this.fetchItemsFromFirebase(fromRef).then(fromItems => {
        fromItems.forEach(item => {
            item.meta.path = toPath
            this.saveItem(item)
        })
        console.log('copyItems reports ' + fromItems.length + ' items copied from ' + this.firebaseRefToPath(fromRef) + ' to ' + toPath + '.')
    })
}

//Copy item from one path to another (key must be included in path)

static copySingleItem(fromRef, toRef) {
    let toPath = this.firebaseRefToPath(toRef)
    let toKey = this.firebaseRefToKey(toRef)
    this.fetchItemSingle(fromRef).then(fromItem => {
        fromItem.meta.path = toPath
        fromItem.meta.key = toKey
        this.saveItem(item)
        console.log('copySingleItem copied from ' + this.firebaseRefToPath(fromItemRef) + ' to ' + toPath + '.', fromItem)
    })
}


} // end class


// WEBPACK FOOTER //
// ./src/data/NiceData.js